import { Copy } from '@ev-tech/ui-core-components/Copy';

export const ListItem = ({ children, className }: { children?: string; className?: string }) => {
  return (
    <li className={className}>
      <Copy size="l" text={children} />
    </li>
  );
};
